// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "BRADFORD_SCORE_OVER_X_IN_Y_MONTHS");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      bradfordScoreOverXInYMonths: {
        required: findSchemaRequired(typeSchema, "bradfordScoreOverXInYMonths"),
        title: "Bradford Score Over X In Y Months",
        properties: {
          bradfordScore: {
            type: "integer",
            title: "Bradford Score",
          },
          dayType: {
            ...findSchemaPropertyByName(typeSchema, "bradfordScoreOverXInYMonths", "dayType"),
            required: null,
          },
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "bradfordScoreOverXInYMonths"],
  };
};

export const uiSchema = (t: (s: string) => string) => baseUiSchema(t);

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
